import { Component } from 'react'

import decode from 'jwt-decode'

class Auth extends Component {
	static checkAuth = () => {
		// Get cached token from localStorage
		const token = localStorage.getItem("token")
		
		if (!token) {
			return false
		} else {
			// Expired Token Check
			const { exp } = decode(token)
			if (exp < new Date().getTime()) {
				localStorage.removeItem("token")
				return false
			}
		}
		// If authenticated, return true for route permission
		return true
	}

	static logout() {
		localStorage.removeItem("token")
	}
}

export default Auth



// WEBPACK FOOTER //
// ./src/auth/Auth.js